var _ellipse, _rect, _rect2, _path, _rect3, _path2, _path3, _path4, _path5, _rect4, _rect5, _path6, _path7, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 526,
    viewBox: "0 0 960 526",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 480,
    cy: 475.5,
    rx: 480,
    ry: 50.5,
    fill: "#022741"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 879,
    y: 461,
    width: 24,
    height: 4,
    fill: "#214967"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 461,
    width: 24,
    height: 4,
    fill: "#214967"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7167 0H935.283L952 15H8L24.7167 0Z",
    fill: "#C1D2DF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 944,
    height: 21,
    fill: "#99B2C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 73H90L82 461.571H63L56 73Z",
    fill: "#2E5A7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M870 73H905L897 461.571H879L870 73Z",
    fill: "#2E5A7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 73H72L64 489H40L32 73Z",
    fill: "#5A85A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M888 73H928L920 489H896L888 73Z",
    fill: "#5A85A5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36,
    width: 928,
    height: 37,
    fill: "#668BA6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36,
    width: 928,
    height: 8,
    fill: "#587F9B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3845 93L32.0011 73.0605V73H71.9999L71.6153 93H32.3845Z",
    fill: "#4A7697"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.231 93H888L887.615 73H927.615L927.231 93Z",
    fill: "#4A7697"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 489,
    width: 24,
    height: 4,
    fill: "#305A79"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 896,
    y: 489,
    width: 24,
    height: 4,
    fill: "#305A79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.074c2708b5e9cc44a03dcd661247e20d.svg";
export { ForwardRef as ReactComponent };